import AccountsPage from '~/routes/accounts'
import AnalyticsPage from '~/routes/analytics'
import BlocksPage from '~/routes/blocks'
import DeployedContractsPage from '~/routes/contracts'
import NftsPage from '~/routes/nfts'
import TokensPage from '~/routes/tokens'
import TransactionsPage from '~/routes/transactions'
import TokenomicsPage from '~/routes/tokenomics'

export const routes = {
  getRootPage () {
    return '/'
  },
  ...BlocksPage,
  ...TransactionsPage,
  ...AccountsPage,
  ...TokensPage,
  ...AnalyticsPage,
  ...TokensPage,
  ...DeployedContractsPage,
  ...NftsPage,  
  ...TokenomicsPage,
}
